/**
 * 기능 ID : COMEKC000-20MS
 * ASIS : addCert.js line 347 ~ 356
 */

import { useTranslation } from 'react-i18next';
import { BottomButtons, PayNow, cn, useDevice } from 'scbk-ui-web';

interface Props {
  onComplete?: () => void;
  isLoading?: boolean;
}

const AdditionalCompleteComponent: React.FC<Props> = ({ onComplete, isLoading = false }) => {
  // 다국어 처리
  const { t } = useTranslation();

  const { isDesktop } = useDevice();

  //   useEffect(() => {
  //     onComplete?.();
  //   }, []);

  return (
    <>
      <div
        className={cn(
          'flex flex-col items-center justify-center h-[calc(100vh-200px)]',
          isDesktop && 'h-[500px] -mt-[30px]',
        )}
      >
        {/* 260527 클래스 삭제 */}
        <span className="block mx-auto">
          <PayNow />
        </span>
        <h2 className="page-heading-title mt-2">{t('AdditionalComponent.082', '인증되었어요')}</h2>
      </div>

      <BottomButtons
        buttons={[
          {
            label: t('AdditionalComponent.127', `확인`),
            onClick: onComplete,
            Variants: 'primary',
            disabled: isLoading,
          },
        ]}
      />
    </>
  );
};

export default AdditionalCompleteComponent;
